import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function useGAPageViews(measurementId) {
  const location = useLocation();

  useEffect(() => {
    if (!window.gtag) return;

    const page_path = location.pathname + location.search;
    const page_location = window.location.href;
    const page_title = document.title;

    window.gtag("event", "page_view", {
      page_title,
      page_location,
      page_path,
    });
  }, [location, measurementId]);
}
